import React from 'react';
import { Card, Col, Row } from 'antd';
import moment from 'moment';
import CardTitle from './CardTitle';

const CardRecharts = ({
  children,
  className,
  title,
  subTitle,
  componentRight = null,
  lastUpdateDate
}) => {
  return (
    <Card
      className={`gx-card-widget gx-h-100 gx-pb-0 gx-mb-0 ${className}`}
      bodyStyle={{
        paddingBottom: 12,
        paddingLeft: 18,
        paddingRight: 18
      }}
    >
      <Row
        className="no-padding no-margin gx-mb-3"
        justify="space-between"
        align="middle"
      >
        <Col>
          <CardTitle title={title} subTitle={subTitle} />
        </Col>
        <Col>{componentRight}</Col>
      </Row>
      <div className="gx-flex-column gx-justify-content-between gx-h-100">
        {children}
      </div>
      {lastUpdateDate && (
        <div className="gx-flex-row gx-text-grey gx-justify-content-end">
          <span>Última atualização: </span>
          <span>{moment(lastUpdateDate).format('DD/MM/YYYY HH:mm')}</span>
        </div>
      )}
    </Card>
  );
};

export default CardRecharts;
